declare var gantt: any;


export default class LinkFormatterSimple implements ILinkFormatter {
	static create = (settings: ILinkFormatterConfig = null): LinkFormatterSimple => {
		return new LinkFormatterSimple();
	}
	protected _linkReg: RegExp;

	constructor() {
		this._linkReg = /^[0-9\.]+/;
	}

	format = (link: ILink) : string => {
		const wbs = this._getWBSCode(link.source);
		return wbs;
	}

	canParse = (value: string) : boolean => {
		return this._linkReg.test(value);
	}
	parse = (value: string) : ILink => {
		if(!this.canParse(value)){
			return null;
		}

		const linkPart = this._linkReg.exec(value)[0].trim();

		const source = this._findSource(linkPart) || null;

		return {
			id: undefined,
			source,
			target: null,
			type: gantt.config.links.finish_to_start,
			lag: 0
		};
	}

	protected _getWBSCode = (source: number | string) => {
		const pred = gantt.getTask(source);
		return gantt.getWBSCode(pred);
	}

	protected _findSource = (value: string) => {
		const reqTemplate = new RegExp("^[0-9\.]+", "i");
		if(reqTemplate.exec(value)){
			const wbs = reqTemplate.exec(value)[0];
			const task = gantt.getTaskByWBSCode(wbs);
			if(task){
				return task.id;
			}
		}
		return null;
	}
}